import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import envConfig from "../envConfig"; // Assuming this contains API_URL

function ResetPassword() {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Parse query parameters from URL
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");
    const uuid = queryParams.get("uuid");

    // Validate query parameters
    if (!email || !uuid) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger text-center" role="alert">
                    Invalid or missing reset link. Please request a new password reset link.
                </div>
            </div>
        );
    }

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Validate password
        if (newPassword !== confirmPassword) {
            Swal.fire({
                title: "Error",
                text: "Passwords do not match!",
                icon: "error",
                confirmButtonText: "OK",
            });
            setLoading(false);
            return;
        }

        if (newPassword.length < 8) {
            Swal.fire({
                title: "Error",
                text: "Password must be at least 8 characters long!",
                icon: "error",
                confirmButtonText: "OK",
            });
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${envConfig.API_URL}/auth/reset_password`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    password_reset_token: uuid,
                    new_password: newPassword,
                }),
            });

            const data = await response.json();

            if (response.ok && data.success) {
                Swal.fire({
                    title: "Success",
                    text: "Your password has been reset successfully! You can now log in with your new password.",
                    icon: "success",
                    confirmButtonText: "Go to Login",
                }).then(() => {
                    navigate("/login"); // Redirect to login page
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: data.message || "Failed to reset password. Please try again.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "An error occurred. Please try again later.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="reset-password-section vh-100 d-flex align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-4">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-4">
                                <div className="text-center mb-4">
                                    <h4 className="mt-3">Reset Your Password</h4>
                                    <p className="text-muted">
                                        Enter a new password for {email}
                                    </p>
                                </div>
                                <form onSubmit={handleResetPassword}>
                                    <div className="mb-3">
                                        <label htmlFor="newPassword" className="form-label">
                                            New Password
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="newPassword"
                                            placeholder="Enter new password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="confirmPassword" className="form-label">
                                            Confirm Password
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="confirmPassword"
                                            placeholder="Confirm new password"
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="d-grid">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    Resetting...
                                                </>
                                            ) : (
                                                "Reset Password"
                                            )}
                                        </button>
                                    </div>
                                </form>
                                <div className="text-center mt-3">
                                    <small>
                                        Remembered your password?{" "}
                                        <a href="/login" className="text-primary">
                                            Log in
                                        </a>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ResetPassword;